import iso from "src/assets/iso.json";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { Router } from "@angular/router";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { ListCollectionItem, ListWorkflow } from "src/app/core/services/outbound";
import {
  user_role_color_map,
  user_role_map,
  user_search_placeholder_map,
} from "src/app/core/services/constants";
import { CommonService } from "src/app/sharedservices/common.service";

@Component({
  selector: "app-rules-selector",
  templateUrl: "./rules-selector.component.html",
  styleUrls: ["./rules-selector.component.scss"],
})

export class RulesSelectorComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() mode = "list";
  @Input() single = false;
  @Input() selectedRules = [];
  @Input() className: string[];
  @Output() selectedNotifier = new EventEmitter<any>();
  @Output() cancelNotifier = new EventEmitter<boolean>(false);
  // bread crumb items
  breadCrumbItems: Array<{}>;
  page: Array<any> = [];
  eop = false;
  pageSize = 24;
  currentPage = 0;
  rulesList: {};
  workflowListSubscription: any;
  monthNames = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  user_search_placeholder_map = {};
  user_role_map = {};
  user_role_color_map = {};
  payload = {};
  ruleListForm: UntypedFormGroup;
  submitted = false;
  dupe = false;
  criterionCount = 0;
  component_ref: any;
  search_message = "";
  countries = [];
  loading = false;
  verifySubscription: any;
  my_id: any;
  selectedRulesList = {};
  moduleDisplay = {
    "order": "Order"
  }

  constructor(
    private ws: WebsocketService,
    private router: Router,
    private formBuilder: UntypedFormBuilder,
    private mdw: MiddlwareService,
    private ref: ChangeDetectorRef,
    private commonService: CommonService
  ) {}

  ngOnInit() {
    // console.log(this.router.url);
    this.countries = iso.map((a) => a.name);
    this.user_role_map = user_role_map;
    this.user_role_color_map = user_role_color_map;
    this.user_search_placeholder_map = user_search_placeholder_map;

    // console.log(this.countries);
    this.component_ref = this.mdw.makeRef(16);
    this.currentPage = 1;
    this.rulesList = {};
    // console.log(Object.keys(this.userList).length);

    this.ruleListForm = this.formBuilder.group({
      chat_id: new UntypedFormControl(null),
      created_date: new UntypedFormControl(null),
      search_type: new UntypedFormControl("name"),
      search_value: new UntypedFormControl(null),
      category: new UntypedFormControl(""),
    });

    this.workflowListSubscription = this.ws.listWorkflowContainer$.subscribe((listRulesData) => {
        if (listRulesData.ref === this.component_ref) {
          if (listRulesData) {
            this.loading = false;
            this.currentPage = listRulesData.page_number;
            if (listRulesData.data.length == 0 && this.currentPage == 1) {
              this.search_message = "No results matched your search criteria";
            }

            listRulesData.data.forEach((rule: any) => {
              rule.created_date = new Date(rule.created_date);
              rule.created_date =
                rule.created_date.getDate() +
                " " +
                this.monthNames[rule.created_date.getMonth()] +
                ", " +
                rule.created_date.getFullYear();
              // rule.country_alpha = iso.find((e) => e.code == rule.country_code)?.alpha;

              this.rulesList[String(rule.id)] = rule;
            });
            // console.log(Object.keys(this.userList).length);

            this.page = [];
            for (let i = 0; i < this.pageSize; i++) {
              if (
                Object.keys(this.rulesList)[
                  i + (this.currentPage - 1) * this.pageSize
                ]
              ) {
                this.page.push(
                  this.rulesList[
                    Object.keys(this.rulesList)[
                      i + (this.currentPage - 1) * this.pageSize
                    ]
                  ]
                );
              }
            }

            document.getElementById("pagination_back").classList.remove("d-none");
            document.getElementById("pagination_back").classList.add("enablePointer");
            document.getElementById("pagination_next").classList.remove("d-none");
            document.getElementById("pagination_next").classList.add("enablePointer");

            this.eop = false;
            if (listRulesData.eop) {
              this.eop = true;
              document.getElementById("pagination_next").classList.add("d-none");
              document.getElementById("pagination_next").classList.remove("enablePointer");
            } else {
              document.getElementById("pagination_next").classList.remove("d-none");
              document.getElementById("pagination_next").classList.add("enablePointer");
            }
            if (this.currentPage == 1) {
              document.getElementById("pagination_back").classList.add("d-none");
              document.getElementById("pagination_back").classList.remove("enablePointer");
            } else {
              document.getElementById("pagination_back").classList.remove("d-none");
              document.getElementById("pagination_back").classList.add("enablePointer");
            }
            if (this.currentPage == 1 && listRulesData.eop) {
              document.getElementById("showPageNumber").classList.add("invisible");
            } else {
              document.getElementById("showPageNumber").classList.remove("invisible");
            }
            this.ref.detectChanges();
          }
        }
      }
    );

    this.verifySubscription = this.ws.verifyContainer$.subscribe((verifyData) => {
      if (verifyData) {
        this.payload["category"] = this.className;
        this.my_id = this.mdw.getID();
        this.loading = true;
        this.ws.processMethod(new ListWorkflow(0, this.pageSize, this.component_ref));
      }
    });

    if (this.selectedRules && this.selectedRules.length > 0) {
      for (let i = 0; this.selectedRules.length > i; i++) {
        this.selectedRulesList[this.selectedRules[i].id] = this.selectedRules[i];
      }
    }
  }


  ngAfterViewInit(): void {
    document.getElementById("pagination_back").classList.add("d-none");
    document.getElementById("pagination_back").classList.remove("enablePointer");
    document.getElementById("pagination_next").classList.add("d-none");
    document.getElementById("pagination_next").classList.remove("enablePointer");
  }

  // convenience getter for easy access to form fields
  get f() {
    return this.ruleListForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if (this.ruleListForm.valid) {
      this.loading = true;

      let id = this.f.search_type.value === "workflow" ? this.f.search_value.value : null;
      let name = this.f.search_type.value === "name" ? this.f.search_value.value : null;
      let created_date = this.f.created_date.value ? this.commonService.dateFormat(this.f.created_date.value) : null;
      this.search(id, name, created_date);
    } else {
      return;
    }
  }

  search(id: any, name: any, created_date: any) {
    this.currentPage = 0;
    this.rulesList = {};
    this.payload = {};
    this.search_message = "";

    if (id != null && id !== "") {
      this.payload["workflow_id"] = id;
    }
    if (name != null && name !== "") {
      this.payload["name"] = name;
    }
    if (created_date != null && created_date !== "") {
      this.payload["created_date"] = created_date;
    }
    this.ws.processMethod(
      new ListWorkflow(
        this.currentPage,
        this.pageSize,
        this.component_ref,
        this.payload["workflow_id"],
        'A',
        this.payload["created_date"],
        this.payload["name"],
      )
    );
  }

  resetSearch() {
    this.currentPage = 0;
    this.rulesList = {};
    this.search_message = "";

    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("chat_id");
    this.payload["category"] = this.className;

    this.ws.processMethod(
      new ListCollectionItem(
        this.currentPage,
        localStorage.getItem("chat_id"),
        this.component_ref,
        this.payload["rule_id"],
        this.payload["name"],
        this.payload["created_date"],
        this.payload["category"]
      )
    );
  }

  nextPage() {
    // console.log("request");
    this.payload["page_size"] = this.pageSize;
    this.payload["page_number"] = this.currentPage;
    this.payload["chat_id"] = localStorage.getItem("chat_id");

    this.ws.processMethod(
      new ListCollectionItem(
        this.currentPage,
        localStorage.getItem("chat_id"),
        this.component_ref,
        this.payload["rule_id"],
        this.payload["name"],
        this.payload["created_date"],
        this.payload["category"]
      )
    );
  }

  backPage() {
    if (this.currentPage != 1) {
      this.currentPage--;
      this.page = [];
      for (let i = 0; i < this.pageSize; i++) {
        if (
          Object.keys(this.rulesList)[
            i + (this.currentPage - 1) * this.pageSize
          ]
        ) {
          this.page.push(
            this.rulesList[
              Object.keys(this.rulesList)[
                i + (this.currentPage - 1) * this.pageSize
              ]
            ]
          );
        }
      }
      if (this.currentPage == 1) {
        document.getElementById("pagination_back").classList.add("d-none");
        document
          .getElementById("pagination_back")
          .classList.remove("enablePointer");
      }
      if (
        this.currentPage <
        Object.keys(this.rulesList).length / this.pageSize
      ) {
        document.getElementById("pagination_next").classList.remove("d-none");
        document
          .getElementById("pagination_next")
          .classList.add("enablePointer");
      }
    }
  }

  editRule(data, event) {
    event.stopPropagation();
    event.preventDefault();
    if (this.single) {
      if (this.selectedRulesList[data.id]) {
        delete this.selectedRulesList[data.id];
      } else {
        this.selectedRulesList = {};
        this.selectedRulesList[data.id] = data;
      }
    } else {
      if (this.selectedRulesList[data.id]) {
        delete this.selectedRulesList[data.id];
      } else {
        this.selectedRulesList[data.id] = data;
      }
    }
  }

  insertEvent() {
    const selected = Object.values(this.selectedRulesList);
    this.selectedNotifier.emit(selected);
  }

  cancelEvent() {
    this.cancelNotifier.emit(true);
  }

  isObjEmpty() {
    return Object.keys(this.selectedRulesList).length === 0;
  }

  isSelected(id: string) {
    return this.selectedRulesList[id] ? true : false;
  }

  ngOnDestroy(): void {
    // console.log("destroy");
    if (this.workflowListSubscription) {
      this.workflowListSubscription.unsubscribe();
    }
    if (this.verifySubscription) {
      this.verifySubscription.unsubscribe();
    }
  }
}
